import * as modelsGet from "../models/get";
import { getTemplates } from "../api/templates";

var templates: modelsGet.ITemplate[];

/**
 * Gibt alle Templates zurück.
 * @param reload Angabe, ob die Status Einträge erneut aus der Datenbank geladen werden sollen.
 */
export async function getTemplatesAsync(reload: boolean = false): Promise<modelsGet.ITemplate[]>
{
    if (templates == null || reload)
    {
        templates = await getTemplates();
    }

    return templates;
}